module.exports = __webpack_public_path__ + "static/media/menu-icon.a2417236.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu-icon.svg
// module id = 877
// module chunks = 7